module.exports = ReactRedux;


//////////////////
// WEBPACK FOOTER
// external "ReactRedux"
// module id = 4
// module chunks = 0